import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../Zumosoft.png';

const NavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  background: #0b0d21;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

const Logo = styled(Link)`
  img {
    width: 220px;
    height: auto;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    img {
      width: 150px;
    }
  }
`;

const NavList = styled.ul`
  display: flex;
  gap: 35px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;

  @media (max-width: 968px) {
    display: none;
  }
`;

const NavItem = styled.li`
  a {
    color: white;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    transition: color 0.3s ease;
    padding: 8px 0;
    border-bottom: 2px solid transparent;

    &:hover {
      color: #8ecf41;
      border-bottom-color: #8ecf41;
    }
  }
`;

const CTAButton = styled(Link)`
  padding: 12px 24px  !important;
  background-color: #8ecf41;
  color: white !important;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  border-bottom: none !important;
  white-space: nowrap;

  &:hover {
    background-color: #72b237;
    transform: translateY(-2px);
  }
`;

const Hamburger = styled.div`
  display: none;
  width: 28px;
  height: 20px;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  div {
    width: 100%;
    height: 3px;
    background: white;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  @media (max-width: 968px) {
    display: flex;
  }
`;

const MobileMenu = styled.div`
  display: ${props => (props.open ? 'block' : 'none')};
  position: absolute;
  top: 65px;
  left: 0;
  right: 0;
  background: #0b0d21;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  a {
    display: block;
    padding: 16px 30px;
    color: white;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: background-color 0.3s ease;

    &:hover {
      background-color: rgba(142, 207, 65, 0.1);
      color: #8ecf41;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  @media (min-width: 969px) {
    display: none;
  }
`;

function Nav() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <NavContainer>
            <Logo to="/">
                <img src={logo} alt="Zumosoft" />
            </Logo>

            <Hamburger onClick={() => setMenuOpen(!menuOpen)}>
                <div></div>
                <div></div>
                <div></div>
            </Hamburger>

            <NavList>
                <NavItem><Link to="/zumodo">ZumoDO</Link></NavItem>
                <NavItem><Link to="/clients">Our Work</Link></NavItem>
                <NavItem><Link to="/about">About</Link></NavItem>
                <NavItem><Link to="/contact">Contact</Link></NavItem>
                <NavItem>
                    <CTAButton
                        as="a"
                        href="https://play.google.com/store/apps/details?id=com.zumodo"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Get the App
                    </CTAButton>
                </NavItem>
            </NavList>

            <MobileMenu open={menuOpen}>
                <Link to="/zumodo" onClick={closeMenu}>ZumoDO</Link>
                <Link to="/clients" onClick={closeMenu}>Our Work</Link>
                <Link to="/about" onClick={closeMenu}>About</Link>
                <Link to="/contact" onClick={closeMenu}>Contact</Link>
                <a
                    href="https://play.google.com/store/apps/details?id=com.zumodo"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeMenu}
                >
                    📱 Try ZumoDO Free for 14 Days
                </a>
            </MobileMenu>
        </NavContainer>
    );
}

export default Nav;